<template>
    <div>

        <!--            计数器-->
        <Wp_access_count page-tag="income"></Wp_access_count>

        <div>
            <Wp_mini_data_card title="今日预估" :datas="today_income_list" :showRight="false" :showEye="false">

            </Wp_mini_data_card>
        </div>

        <div style="padding-top: 20px">
            <Wp_mini_data_card title="本月预估" :datas="month_income_list" :showRight="false" :showEye="false">

            </Wp_mini_data_card>
        </div>

        <div style="box-shadow: 1px 1px 5px #999999; margin-top: 20px; font-weight: bold;">
            <van-cell title="我的总预估收入详情" size="large" is-link @click="showIncomeDetail"/>
            <van-cell title="我的推广预估收入详情" size="large" is-link @click="showIncomeSelfDetail"/>
        </div>

<!--        <div v-if="$common.getLimitPayTime().canPay && $config.project !== 'hm'" style="padding: 10px; margin-top: 10px">-->
<!--            <van-button type="danger" size="large" @click="payDataDetail">提 款</van-button>-->
<!--        </div>-->

    </div>
</template>

<script>
    import Wp_mini_data_card from "../custom/Wp_mini_data_card";
    import Wp_access_count from "../custom/Wp_access_count";
    export default {
        name: "Wp_order_count_new",
        components: {Wp_access_count, Wp_mini_data_card},
        // props: {
        //     pid: {
        //         type: String,
        //         default: null
        //     }
        // },
        data() {
            return {
                pid: "",
                active: '1',
                title:'今日数据',
                startTime:this.$store.state.startTime,
                endTime:this.$store.state.endTime,
                countData: {
                    code: 200,
                    efeed18: 0, //当天已结算金额
                    efeem18: 0,  //本月已结算金额
                    efeemonth: 0,  //本月预估收入
                    efeetoday: 0, //当天预估收入
                    epricemonth: 0,  //本月商品总额
                    epricetoday: 0,  //当天商品总额
                    msg: "sucess",
                },

                monthCountData: {
                    code: 200,
                    efeed18: 0, //当天已结算金额
                    efeem18: 0,  //本月已结算金额
                    efeemonth: 0,  //本月预估收入
                    efeetoday: 0, //当天预估收入
                    epricemonth: 0,  //本月商品总额
                    epricetoday: 0,  //当天商品总额
                    msg: "sucess",
                },

                orderCount : 0,

                efeetodayall: 0,

                today_income_list: [
                    // {
                    //     count: 0.00,
                    //     count_unit: "￥",
                    //     text: "今日推广收益"
                    // }
                ],
                month_income_list: [
                    // {
                    //     count: 0.00,
                    //     count_unit: "￥",
                    //     text: "本月推广收益"
                    // }
                ],


            }
        },
        created() {
            this.$log("this.startTime = " + this.startTime)
            this.pid = this.$common.getPid();
            this.getOrderCountBy();
        },
        mounted(){
            // this.getMonthCount();
        },
        methods: {

            showIncomeSelfDetail(){
                this.$router.push("count_self_detail_page")
            },

            showIncomeDetail(){
                this.$router.push("count_detail_page")
            },

            /**
             * 初始化"我的收益"数据
             */
            // initTodayIncome(){
            //     let time = this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', 0, new Date()));
            //     let _data = {
            //         pid: this.pid,
            //         stime: time,
            //         etime: time,
            //     };
            //
            //     this.$getIncometByData(_data, response=> {
            //         this.$log(response)
            //         if(response && response.code === 200){
            //             this.countData = response;
            //             this.efeetodayall = Number(response.efeetodayall).toFixed(2);
            //
            //             this.initTadayIncomeDatas(response);
            //         }
            //     })
            //
            // },

            getOrderCountBy() {
                let today_date = this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', 0, new Date()));
                let _data = {
                    pid: this.$common.getPid(),
                    stime: this.startTime,
                    etime: this.endTime,
                };
                this.$log(_data);
                // this.$getOrderCountByData(_data, function (response) {
                //     that.countData = response;
                //     that.$log(response);
                // })
                this.$getIncometByData(_data, response=> {

                    this.$log(response);
                    if(response && response.code === 200){
                        this.countData = response;
                        this.efeetodayall = Number(response.efeetodayall).toFixed(2);
                        if(this.startTime === today_date && this.endTime === today_date){
                            this.$log("初始化今日数据")

                            this.initTadayIncomeDatas(response);
                        }
                    }
                })

            },

            initTadayIncomeDatas(response){
                if(response.type === "0"){

                    this.today_income_list = [
                        {
                            count: response.efeetodayall_user.toFixed(2),
                            count_unit: "￥",
                            text: "今日推广收益"
                        },
                        {
                            count: response.efeetodayall_he.toFixed(2),
                            count_unit: "￥",
                            text: "今日推荐收益"
                        },
                        {
                            count: response.efeetodayall.toFixed(2),
                            count_unit: "￥",
                            text: "今日全部收益"
                        }
                    ];
                    this.month_income_list = [
                        {
                            count: response.m_efeetodayall_user.toFixed(2),
                            count_unit: "￥",
                            text: "本月推广收益"
                        },
                        {
                            count: response.m_efeetodayall_he.toFixed(2),
                            count_unit: "￥",
                            text: "本月推荐收益"
                        },
                        {
                            count: response.m_efeetodayall.toFixed(2),
                            count_unit: "￥",
                            text: "本月全部收益"
                        }
                    ];
                }else if(response.type === "1" || response.type === "2"){

                    this.today_income_list = [
                        {
                            count: response.efeetodayall_user.toFixed(2),
                            count_unit: "￥",
                            text: "今日推广收益"
                        },
                        {
                            count: response.efeetodayall_he.toFixed(2),
                            count_unit: "￥",
                            text: "今日推荐收益"
                        },
                        {
                            count: response.efeetodayall_other.toFixed(2),
                            count_unit: "￥",
                            text: "今日专属收益"
                        },
                        {
                            count: response.efeetodayall.toFixed(2),
                            count_unit: "￥",
                            text: "今日全部收益"
                        }
                    ];
                    this.month_income_list = [
                        {
                            count: response.m_efeetodayall_user.toFixed(2),
                            count_unit: "￥",
                            text: "本月推广收益"
                        },
                        {
                            count: response.m_efeetodayall_he.toFixed(2),
                            count_unit: "￥",
                            text: "本月推荐收益"
                        },
                        {
                            count: response.m_efeetodayall_other.toFixed(2),
                            count_unit: "￥",
                            text: "本月专属收益"
                        },
                        {
                            count: response.m_efeetodayall.toFixed(2),
                            count_unit: "￥",
                            text: "本月全部收益"
                        }
                    ];
                }else{
                    this.today_income_list = [
                        {
                            count: 0,
                            count_unit: "￥",
                            text: "今日收益"
                        }
                    ];
                }
            },


            /**
             * 提款
             */
            payDataDetail(){
                // if(this.$store.state.userPhone && this.$store.state.userPhone !== "0"){
                //     this.$router.push('paydata');
                // }else{
                //     this.$dialog.confirm({
                //         message: "请绑定手机号",
                //     }).then(()=>{
                //         this.$router.push("update_phone");
                //     }).catch(()=>{
                //
                //     })
                // }

                //如果是小程序中，则直接打开提款界面
                if(this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.open_id){
                    this.$router.push('paydata');
                }else{
                    this.$common.pay_from_data_page = true;
                    this.$router.push('my');
                }
            },

            // getMonthCount() {
            //     let currentDate = new Date();
            //     let year = currentDate.getFullYear();
            //     let month = currentDate.getMonth();
            //     let start_time = this.$common.dateFmt("yyyy-MM-dd", new Date(year, month, "1"));
            //     let end_time = this.$common.dateFmt("yyyy-MM-dd", currentDate);
            //
            //     let _data = {
            //         pid: this.$store.state.pid,
            //         stime: start_time,
            //         etime: end_time,
            //     };
            //     this.$log(_data);
            //     let that = this;
            //     this.$getOrderCountByData(_data, function (response) {
            //         that.monthCountData = response;
            //         that.$log(response);
            //     })
            // },

            // showTitle(){
            //     let testTime_1=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', 0, new Date()));
            //     let testTime_2=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', -1, new Date()));
            //     if(testTime_1===this.startTime && testTime_1===this.endTime){
            //         this.title='今日数据'
            //     }else  if(testTime_2===this.startTime && testTime_2===this.endTime){
            //         this.title='昨日数据'
            //     }else if(this.startTime===this.endTime){
            //         this.title='数据('+this.startTime+')'
            //     }else{
            //         this.title=this.startTime+' 至 '+this.endTime+' 数据'
            //     }
            // },

            // selectDateCount(selectDate) {
            //     this.$log("111");
            //     this.$log(selectDate);
            //     this.startTime = selectDate.startTime;
            //     this.endTime = selectDate.endTime;
            //     this.getOrderCountBy();
            //     this.showTitle();
            // },

            // getOrderCount(count){
            //     this.orderCount = count;
            //     this.$log("this.orderCount = " + this.orderCount);
            // }
        }
    }
</script>

<style scoped>

</style>
